import React, {useContext, useEffect, useState} from 'react';

import {useOktaAuth} from '@okta/okta-react';

import Loading from '@pb/kit-component-loading';

import {AuthenticationContext} from '../authentication-context';

type Props = {
    children: React.ReactElement,
};

export const OktaAuthenticationController: React.FC<Props> = ({children}) => {
    const {oktaAuth, authState} = useOktaAuth();
    const {isLogoutRequested, requestLogout} = useContext(AuthenticationContext);

    const [showContent, setShowContent] = useState(false);

    useEffect(() => {
        if (oktaAuth.signOut && isLogoutRequested) {
            oktaAuth.signOut({postLogoutRedirectUri: window.location.origin + '/logout'});
            requestLogout(false);
        }
    }, [oktaAuth, isLogoutRequested, requestLogout]);

    useEffect(() => {
        if (authState && !authState.isAuthenticated) {
            const currentPath = window.location.pathname;
            if (currentPath !== '/login/callback') {
                oktaAuth.signInWithRedirect();
            }
        }

        if (authState?.isAuthenticated) {
            setShowContent(true);
        }
    }, [authState, oktaAuth]);

    return showContent ? children : <Loading fast={true}/>;
};
